import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgStoring = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="M19 22v3h-9l9-13z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M21.425 4 9 22.669l9.575-.25V35L31 16.503h-9.575z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="m21.5 32.298 8.08-12.568.84.54-9.92 15.432V24h1zM18.5 6.5l-2.1 2.8-.8-.6 3.9-5.2V15h-1z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgStoring);

export default ForwardRef;
